/* eslint-disable eqeqeq */
import {useState, useEffect, useRef} from "react";

export function SearchableDropdown({
	name,
	data = [],
	value,
	onSelect,
	onBlur,
	onChange,
	disabled,
	className = "form-control",
	emptyText = "Data tidak ditemukan",
	placeholder = "Select...",
	returnObject,
	...props
}) {
	const [query, setQuery] = useState("");
	const [filtered, setFiltered] = useState(data);
	const [show, setShow] = useState(false);
	const wrapperRef = useRef(null);

	useEffect(() => {
		if (query === "") {
			setFiltered(data);
		} else {
			setFiltered(data.filter(item => item.label.toLowerCase().includes(query.toLowerCase())));
		}
	}, [query, data]);

	useEffect(() => {
		if (value) {
			const selectedItem = data.find(d => d.value == value);

			if (selectedItem) {
				setQuery(selectedItem.label);
			}
		}
	}, [value, data]);

	useEffect(() => {
		const handleClickOutside = event => {
			if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
				setShow(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleSelect = item => {
		setQuery(item.label);
		setShow(false);
		if (returnObject) {
			onSelect(item.value, item?.objectData);
		} else {
			onSelect(item.value);
		}
	};

	return (
		<div ref={wrapperRef} className="position-relative" style={{width: "100%"}}>
			<input
				className={className}
				disabled={disabled}
				name={name}
				placeholder={placeholder}
				type="text"
				value={query}
				onBlur={onBlur}
				onChange={e => {
					setQuery(e.target.value);
					onChange && onChange(e);
					setShow(true);
				}}
				onFocus={() => setShow(true)}
				{...props}
			/>
			{show && (
				<div
					className="position-absolute w-100 bg-white shadow rounded mt-1"
					style={{zIndex: 1000, maxHeight: "200px", overflowY: "auto"}}>
					{filtered.length > 0 ? (
						filtered.map((item, i) => (
							<div
								key={i}
								className="px-3 py-2"
								style={{cursor: "pointer"}}
								onMouseDown={() => handleSelect(item)} // gunakan onMouseDown supaya tidak blur duluan
								onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#f8f9fa")}
								onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}>
								{item.label}
							</div>
						))
					) : (
						<div className="px-3 py-2 text-center text-muted">{emptyText}</div>
					)}
				</div>
			)}
		</div>
	);
}
